/*****************************
 *       Form utilities      *
 ****************************/
window.formUtils = {
    /**
     * Toggle field on checkbox
     * @param checkName
     * @param fieldId
     */
    toggleCheckField: function(checkName, fieldId) {
        const check = $(`input[id=${checkName}]`);
        const field = $('#' + fieldId);
        check.bind('click dblclick', function(evt) {
            if ($(this).is(":checked")) {
                field.slideDown('fast');
            } else {
                field.slideUp('fast')
            }
        });
        if (check.prop('checked')) {
            field.collapse('show');
        }
    },
    /**
     * Toggle field disabled on radio YES/NO
     * @param radioName
     * @param fieldId
     */
    toggleRadioField: function (radioName, fieldId) {
        const radio = $(`input[name=${radioName}]`);
        const field = $('#' + fieldId);

        // On radio change, show/hide
        radio.change(function() {
            if (radio.filter(':checked').val().toUpperCase() === 'YES') {
                field.slideDown('fast');
            } else {
                field.slideUp('fast');
            }
        });

        // On page load, show if checked
        let value = radio.filter(':checked').val();
        if (value && value.toUpperCase() === 'YES') {
            field.collapse('show')
        }
    },
    /**
     * Toggle field on select
     * @param name of the select
     * @param value of the select
     * @param fieldId
     */
    toggleSelectField: function(name, value, fieldId) {
        const check = $(`select[id=${name}]`);
        const field = $('#' + fieldId);
        check.change(() => {
            if (check.val() === value) {
                field.slideDown('fast');
            } else {
                field.slideUp('fast');
            }
        });
        if (check.val() === value) {
            field.collapse('show');
        }
    },
    changeInputs: function() {
        $('.custom-file-input').on('change', function() {
            let fileName = $(this).val().split('\\').pop();
            $(this).next('.custom-file-label').addClass("selected").html(fileName);
        });
    }
};
